module.exports = __webpack_public_path__ + "static/media/ts.7d39fef8.svg";